import React from "react";
import { Link } from "react-router-dom";
// OPTION A: if the SVG is in /src/assets
// import NotFoundArt from "../assets/404-illustration.svg";
// OPTION B: if the SVG is in /public
// const NotFoundArt = "/404-illustration.svg";

// If you saved the provided image as "404 Error-amico.svg" in /public:


export default function NotFoundPage() {
  return (
    <div className="min-vh-100 d-flex align-items-center">
      <div className="container py-5">
        <div className="row g-4 align-items-center justify-content-center">
          {/* Illustration */}
          <div className="col-11 col-sm-8 col-md-6 ms-lg-4 col-lg-5 order-1 order-md-2 text-center">
            <img
              src="assets/images/404.png"
              alt="Page not found"
              className="img-fluid"
              style={{ maxHeight: 480 }}
            />
          </div>

          {/* Text + actions */}
          <div className="col-11 col-sm-10 col-md-6 col-lg-5 order-2 order-md-1">
            <div >
              <div className="card-body p-4 p-lg-5">
               
                <h1 className="h3 fw-bold mb-2">Oops! Looks like you took a wrong turn.</h1>
                <p className="text-muted mb-4">
                  This page doesn’t exist — but don’t worry, you can get back on track.
                </p>

                <div className="d-flex flex-wrap gap-2">
                  <Link to="/login" className="btn btn-primary">
                    Go to Home
                  </Link>
                
                </div>

                {/* Optional help text */}
                <div className="mt-4 small text-muted">
                  Need help? <a href="/support" className="text-decoration-none">Contact support</a>.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer (optional) */}
        <div className="text-center text-muted small mt-4">
          © {new Date().getFullYear()} ProjeX. All rights reserved.
        </div>
      </div>
    </div>
  );
}
